// extracted by mini-css-extract-plugin
export default {"imgdiv":"_1244848200 _7060d8b20a","img":"a113c35433 ea36f62f76"};